// @flow
import { createSelector } from "reselect"
import type { Combination } from "@kiwicom/nitro/lib/records/Baggage"

import {
  BaggageModule,
  BaggageOrderFailedAction,
} from "../../../../../../../services/tracking/constants/trackingEvents"
import mmbTrack from "../../../../../../../services/tracking/mmbTrack"

export type HandHoldCombinations = { [passenger_id: string]: Combination }

export const getAllCombinationsSelector: (
  state: any,
  props: any,
) => HandHoldCombinations = createSelector(
  [state => state.bookingBaggage.baggage],
  baggage => {
    return { ...baggage.combinations.handBag, ...baggage.combinations.holdBag }
  },
)

const commonErrors = [
  "can't create bags order anymore",
  "Error: Unauthorized",
  "Not allowed to view this BID",
  "can't order this number of bags",
  "price change",
  "pending order exists",
  "TypeError: Failed to fetch",
  "Not allowed to view this BID",
  "TypeError: The network connection was lost.",
  "TypeError: A server with the specified hostname could not be found.",
  "price change",
  "TypeError: The request timed out.",
  "Error: Unauthorized",
  "TypeError: The operation couldn't be completed. Software caused connection abort",
  "pending order exists",
  "can't order this number of bags",
  "can't create bags order anymore",
  "TypeError: An SSL error has occurred and a secure connection to the server cannot be made.",
  "Error: Unauthorized",
  "Not allowed to view this BID",
  "price change",
  "pending order exists",
]

// $FlowFixMe
export const trackOrderError = error => {
  const errorDetail = error?.data?.detail
  if (commonErrors.includes(errorDetail)) {
    mmbTrack(
      { module: BaggageModule, action: BaggageOrderFailedAction, detail: errorDetail },
      { error: errorDetail },
    )
  } else {
    mmbTrack(
      { module: BaggageModule, action: BaggageOrderFailedAction, detail: "unknown error" },
      { error: errorDetail },
    )
  }
}
